import { post, get, put, deleteApi } from './axiosFun';
//试卷新增
export const examPaperAdd = (params) => { return post("/edu/exam-paper/examPaperAdd", params) };
//试卷详情
export const examPaperDetail = (examPaperId) => { return get(`/edu/exam-paper/examPaperDetail/${examPaperId}`) };

//试卷编辑
export const examPaperEdit = (params) => { return put("/edu/exam-paper/examPaperEdit", params) };
//试卷列表
export const examPaperList = (params) => { return post("/edu/exam-paper/examPaperList", params) };
//试卷分页
export const examPaperPage = (params) => { return post("/edu/exam-paper/examPaperPage", params) };
//试卷批量发布
export const examPaperPublish = (params) => { return post("/edu/exam-paper/examPaperPublish", params) };

//试卷批量删除
export const examPaperRemove = (params) => { return post("/edu/exam-paper/examPaperRemove", params) };


//考试统计分页
export const examStatPage = (params) => { return post("/edu/exam/examStatPage", params) };


//考试记录分页
export const examRecordPage = (params,header) => { return post("/edu/exam/examRecordPage", params,header) };

//个人考试记录分页
export const myExamRecordPage = (params,header) => { return post("/edu/exam/myExamRecordPage", params,header) };


// WEBPACK FOOTER //
// ./src/api/exam.js